import { createInstance } from 'antd-style'

/**
 * 编辑器内容区域的样式一定要用这个实例创建，不然可能会导致预览效果跟编辑器不一致
 */
export const {
  createStyles: createEditorStyles,
  css: editorCss,
  styleManager: editorStyleManager
} = createInstance({
  key: 'contract-designer-editor'
})

export const getEditorStyleSheet = (): string => {
  return editorStyleManager.sheet.tags
    .map(styleDom => styleDom.innerText + '\n')
    .join('')
}
